import { useState } from 'react';
import styles from './DashboardPage.module.scss';

type CountryTab = 'india' | 'us' | 'canada';

const countryTabs: { id: CountryTab; label: string }[] = [
    { id: 'india', label: 'India' },
    { id: 'us', label: 'United States' },
    { id: 'canada', label: 'Canada' },
];

const mockAssets = {
    india: [
        {
            id: '1',
            name: 'NRE Fixed Deposit',
            institution: 'HDFC Bank',
            detail: 'Maturing Oct 2025',
            balance: '₹ 12,50,000',
            change: '+8.5%',
        },
        {
            id: '2',
            name: 'HDFC Savings',
            institution: 'Platinum Tier',
            detail: 'Acc ending ...4402',
            balance: '₹ 4,85,200',
            change: '+3.2%',
        },
        {
            id: '3',
            name: 'Gurgaon Portfolio',
            institution: 'Residential',
            detail: 'DLF Phase 5',
            balance: '₹ 8,25,14,750',
            change: '-10.2%',
        },
    ],
    us: [
        {
            id: '4',
            name: '401(k)',
            institution: 'Fidelity',
            detail: 'Employer Match',
            balance: '$ 285,000',
            change: '+12.1%',
        },
        {
            id: '5',
            name: 'Roth IRA',
            institution: 'Schwab',
            detail: 'Index Funds',
            balance: '$ 78,500',
            change: '+9.8%',
        },
    ],
    canada: [
        {
            id: '6',
            name: 'RRSP',
            institution: 'TD Bank',
            detail: 'Balanced Portfolio',
            balance: 'C$ 42,000',
            change: '+6.3%',
        },
        {
            id: '7',
            name: 'TFSA',
            institution: 'Wealthsimple',
            detail: 'Growth ETFs',
            balance: 'C$ 28,750',
            change: '+11.4%',
        },
    ],
};

export function DashboardPage() {
    const [activeTab, setActiveTab] = useState<CountryTab>('india');

    return (
        <div className={styles.page}>
            <div className={styles.pageHeader}>
                <div>
                    <h1 className={styles.title}>Accounts Overview</h1>
                    <p className={styles.subtitle}>Real-time valuation across your global footprint.</p>
                </div>
                <div className={styles.tabs}>
                    {countryTabs.map((tab) => (
                        <button
                            key={tab.id}
                            className={`${styles.tab} ${activeTab === tab.id ? styles.active : ''}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>

            <div className={styles.totalCard}>
                <span className={styles.totalLabel}>
                    {activeTab === 'india'
                        ? 'TOTAL INDIA LIQUIDITY'
                        : activeTab === 'us'
                          ? 'TOTAL US ASSETS'
                          : 'TOTAL CANADA ASSETS'}
                </span>
                <div className={styles.totalValue}>
                    <span className={styles.amount}>
                        {activeTab === 'india' ? '₹ 1,42,50,000' : activeTab === 'us' ? '$ 363,500' : 'C$ 70,750'}
                    </span>
                    <span className={styles.currency}>
                        {activeTab === 'india' ? 'INR' : activeTab === 'us' ? 'USD' : 'CAD'}
                    </span>
                    <span className={styles.changePositive}>+12.4% Annualized</span>
                </div>
                <span className={styles.syncTime}>Last synced 14 minutes ago</span>
            </div>

            <div className={styles.assetsGrid}>
                {mockAssets[activeTab].map((asset) => (
                    <div key={asset.id} className={styles.assetCard}>
                        <div className={styles.assetHeader}>
                            <span className={styles.assetName}>{asset.name}</span>
                            <span
                                className={asset.change.startsWith('+') ? styles.changePositive : styles.changeNegative}
                            >
                                {asset.change}
                            </span>
                        </div>
                        <p className={styles.assetDetail}>
                            {asset.institution} &bull; {asset.detail}
                        </p>
                        <div className={styles.assetBalance}>
                            <span className={styles.balanceLabel}>
                                {asset.name.includes('Portfolio') ? 'Estimated Value' : 'Current Balance'}
                            </span>
                            <span className={styles.balanceValue}>{asset.balance}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
